import { render, staticRenderFns } from "./solicitar-vacaciones.vue?vue&type=template&id=0e2f54c5&scoped=true"
import script from "./solicitar-vacaciones.vue?vue&type=script&lang=js"
export * from "./solicitar-vacaciones.vue?vue&type=script&lang=js"
import style0 from "./solicitar-vacaciones.vue?vue&type=style&index=0&id=0e2f54c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2f54c5",
  null
  
)

export default component.exports